import classNames from 'classnames';
import DeviceManager from '@/components/util/deviceManager';

const LoadTourIframe = ({
  mesurementsOn,
  iframeStyle,
  cb,
  iframeUrl,
  isFullScreen,
}: {
  cb: (el: any) => void;
  iframeStyle: any;
  mesurementsOn: any;
  iframeUrl?: string | null;
  isFullScreen: boolean;
}) => {
  return (
    <iframe
      title="showcase"
      className={classNames('showcase', DeviceManager.isMobile() && !isFullScreen && mesurementsOn && 'mesurements-mobile-not-fullscreen')}
      ref={(el) => {
        cb(el);
      }}
      style={iframeStyle}
      frameBorder={0}
      allow="fullscreen,vr,autoplay"
      allowFullScreen
      src={iframeUrl}
    />
  );
};

export default LoadTourIframe;
